import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const settingsService = {
  // Get all settings with pagination and filtering
  getSettings: async (params = {}) => {
    const response = await api.get('/settings', { params });
    return response.data;
  },

  // Get public settings (no authentication required)
  getPublicSettings: async () => {
    const response = await api.get('/settings/public');
    return response.data;
  },

  // Get setting by ID
  getSetting: async (id) => {
    const response = await api.get(`/settings/${id}`);
    return response.data;
  },

  // Get setting by key
  getSettingByKey: async (key) => {
    const response = await api.get(`/settings/key/${key}`);
    return response.data;
  },

  // Create new setting
  createSetting: async (settingData) => {
    const response = await api.post('/settings', settingData);
    return response.data;
  },

  // Update setting by ID
  updateSetting: async (id, settingData) => {
    const response = await api.put(`/settings/${id}`, settingData);
    return response.data;
  },

  // Update setting by key
  updateSettingByKey: async (key, value) => {
    const response = await api.put(`/settings/key/${key}`, { value });
    return response.data;
  },

  // Delete setting
  deleteSetting: async (id) => {
    const response = await api.delete(`/settings/${id}`);
    return response.data;
  },

  // Get setting categories
  getCategories: async () => {
    const response = await api.get('/settings/categories/list');
    return response.data;
  },

  // Bulk update settings
  bulkUpdateSettings: async (settings) => {
    const response = await api.put('/settings/bulk/update', { settings });
    return response.data;
  },

  // Initialize default settings
  initializeSettings: async () => {
    const response = await api.post('/settings/initialize');
    return response.data;
  },

  // Get settings by category
  getSettingsByCategory: async (category) => {
    const response = await api.get('/settings', { 
      params: { category, limit: 1000 } 
    });
    return response.data;
  },

  // Search settings
  searchSettings: async (searchTerm) => {
    const response = await api.get('/settings', { 
      params: { search: searchTerm, limit: 1000 } 
    });
    return response.data;
  }
};

export default settingsService; 